import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TextField, type TextFieldProps } from '@mui/material';
import { LocalizationProvider, MobileDatePicker } from '@mui/x-date-pickers-pro';
import { dateFormat } from '@utils/dates';
import { CalendarIcon } from '../assets';

interface SingleDatePickerProps {
    date: string | null;
    setDate: (date: string | null) => void;
    buttonSize?: { width: number; height: number };
    dateError?: string;
    disabled?: boolean;
}

export const SingleDatePicker = ({ dateError, setDate, date, buttonSize, disabled = false }: SingleDatePickerProps) => {
    const handleDateChange = (date: string | null) => {
        setDate(date ? dateFormat(date) : date);
    };

    const renderInput = (props: TextFieldProps) => (
        <TextField
            disabled={disabled}
            size={'small'}
            {...props}
            label={''}
            sx={{ '& legend': { display: 'none' }, '& fieldset': { top: 0 }, maxWidth: '150px' }}
            InputProps={{
                style: { backgroundColor: 'white', ...buttonSize },
                readOnly: true,
                endAdornment: <CalendarIcon />,
            }}
            InputLabelProps={{ shrink: true }}
            helperText={dateError ?? ''}
            error={Boolean(dateError)}
        />
    );

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <MobileDatePicker
                disablePast
                disabled={disabled}
                value={date}
                onChange={handleDateChange}
                renderInput={renderInput}
            />
        </LocalizationProvider>
    );
};
